/*
injects the bespokeid property
hooks into AJAX calls and re-injects property as necessary
(c) Min Liu 2020
*/
var Bespoke = (function () {
  var enhancedCompatibilityMode = false;
  var bespokeIdVar = '_bespokeid';
  var bespokeKeyVar = '_bskey';
  var cartToken = null;
  var addProps = function ($) {
    // Skip if bespoke script is locked (e.g. during GWP item addition)
    if (window.bespokeGWPLock === true) {
      return;
    }

    var bespokeCartData = {};

    // get current cart
    $('[name=checkout]').prop('disabled', true).addClass('disabled');
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      processData: false,
      dataType: 'json',
      success: function (cart) {
        var firstShippableProductIdx = null;
        var hasBespokeID = false;

        cartToken = cart.token;
        thisToken = cartToken;

        for (idx = 0; idx < cart.items.length; idx++) {
          var item = cart.items[idx];
          if (!item.requires_shipping) continue;
          if (firstShippableProductIdx === null) firstShippableProductIdx = idx;
          if (item.properties && item.properties[bespokeIdVar]) {
            hasBespokeID = true;
          }
        }

        if (enhancedCompatibilityMode) {
          // add cartToken to first line item only but key to all line items
          for (idx = 0; idx < cart.items.length; idx++) {
            var item = cart.items[idx];
            if (!item.requires_shipping) continue;

            var thisHasBespokeKey = false;
            if (item.properties && item.properties[bespokeKeyVar]) thisHasBespokeKey = true;

            var thisKey = '';
            if (item.key) {
              thisKey = item.key.replace(item.variant_id + ':', '');
              thisKey =
                thisKey.substring(0, 2) + thisKey.substring(thisKey.length - 2) + '-' + Math.floor(Date.now() / 1000);
            }

            if (!hasBespokeID || !thisHasBespokeKey) {
              // Use item key (id) instead of line number for reliable identification
              // bespokeCartData.line = idx + 1;
              bespokeCartData.id = item.key;
              bespokeCartData.quantity = item.quantity;
              bespokeCartData.properties = item.properties;
              if (bespokeCartData.properties === null) bespokeCartData.properties = {}; //no existing properties
              if (!hasBespokeID) {
                // only add the bespoke ID if not already set on another line
                bespokeCartData.properties[bespokeIdVar] = thisToken;
                hasBespokeID = true;
              }
              // add the key on all line items if not set
              if (!thisHasBespokeKey) {
                bespokeCartData.properties[bespokeKeyVar] = thisKey;
              }
              $.ajax({
                url: '/cart/bespokechange.js',
                type: 'POST',
                async: false,
                dataType: 'json',
                data: bespokeCartData,
                success: function (data) {
                  $('[name=checkout]').prop('disabled', false).removeClass('disabled');
                },
                error: function () {
                  $('[name=checkout]').prop('disabled', false).removeClass('disabled');
                },
              });
            } else {
              // nothing further to do
              $('[name=checkout]').prop('disabled', false).removeClass('disabled');
            }
          }
        } else {
          // add cartToken to first line item only
          if (!hasBespokeID && firstShippableProductIdx !== null) {
            var item = cart.items[firstShippableProductIdx];
            // Use item key (id) instead of line number for reliable identification
            // bespokeCartData.line = firstShippableProductIdx + 1;
            bespokeCartData.id = item.key;
            bespokeCartData.quantity = item.quantity;
            bespokeCartData.properties = item.properties;
            if (bespokeCartData.properties === null) bespokeCartData.properties = {}; //no existing properties
            bespokeCartData.properties[bespokeIdVar] = thisToken;
            $.ajax({
              url: '/cart/bespokechange.js',
              type: 'POST',
              dataType: 'json',
              data: bespokeCartData,
              success: function (data) {
                $('[name=checkout]').prop('disabled', false).removeClass('disabled');
              },
              error: function () {
                $('[name=checkout]').prop('disabled', false).removeClass('disabled');
              },
            });
          } else {
            // nothing further to do
            $('[name=checkout]').prop('disabled', false).removeClass('disabled');
          }
        }
      },
      error: function () {
        $('[name=checkout]').prop('disabled', false).removeClass('disabled');
      },
    });
  };
  var addAjaxHooks = function ($) {
    // XHR
    var oldOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function () {
      if (arguments[1].indexOf('bespokechange.js') > -1) {
        arguments[1] = arguments[1].replace('bespokechange.js', 'change.js');
      } else {
        if (
          arguments[1].indexOf('/cart/add') > -1 ||
          arguments[1].indexOf('/cart/change') > -1 ||
          arguments[1].indexOf('/cart/update') > -1
        ) {
          this.addEventListener('load', function () {
            addProps($);
          });
        }
      }
      oldOpen.apply(this, arguments);
    };
    //Fetch
    const _fetch = window.fetch;
    window.fetch = function () {
      return new Promise((resolve, reject) => {
        _fetch
          .apply(this, arguments)
          .then((response) => {
            if (
              response.url.indexOf('/cart/add') > -1 ||
              response.url.indexOf('/cart/change') > -1 ||
              response.url.indexOf('/cart/update') > -1
            ) {
              addProps($);
            }
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    };
  };
  var hideBespokeIDLabel = function ($) {
    $(document).ready(function () {
      // find the lowest div elm
      $("div:contains('" + bespokeIdVar + "')").each(function () {
        var h = $(this).html();
        if (h.includes('div')) return; //continue - find the closest div
        h = h.replace(/_bespokeid:[\s\S]+[a-z0-9]{32}(:[a-z0-9]{32})?/g, '');
        $(this).html(h);
        return false;
      });
      //alternative
      $("span:contains('" + bespokeIdVar + "')").each(function () {
        if (typeof $(this).attr('data-cart-item-property') !== 'undefined') {
          $(this).hide();
        } else if (typeof $(this).parent().attr('data-cart-item-property') !== 'undefined') {
          $(this).parent().hide();
        }
      });
      if (enhancedCompatibilityMode) {
        $("div:contains('" + bespokeKeyVar + "')").each(function () {
          var h = $(this).html();
          if (h.includes('div')) return; //continue - find the closest div
          h = h.replace(/_bskey:[\s\S]+[a-z0-9]{32}(:[a-z0-9]{32})?/g, '');
          $(this).html(h);
          return false;
        });
        //alternative
        $("span:contains('" + bespokeKeyVar + "')").each(function () {
          if (typeof $(this).attr('data-cart-item-property') !== 'undefined') {
            $(this).hide();
          } else if (typeof $(this).parent().attr('data-cart-item-property') !== 'undefined') {
            $(this).parent().hide();
          }
        });
      }
    });
  };
  var run = function ($) {
    addAjaxHooks($);
    addProps($);
    hideBespokeIDLabel($);
  };
  var waitjQueryLoad = function (cb) {
    if (window.jQuery) {
      cb(jQuery);
    } else {
      // reschedule
      window.setTimeout(function () {
        waitjQueryLoad(cb);
      }, 100);
    }
  };
  var jquery;
  if (typeof Bespoke !== 'undefined') {
    return;
  }
  if (typeof _BESPOKE_ENHANCED_COMPATIBILITY_MODE !== 'undefined')
    enhancedCompatibilityMode = _BESPOKE_ENHANCED_COMPATIBILITY_MODE;
  if (window.jQuery) {
    jquery = window.jQuery;
  } else if (window.Checkout && window.Checkout.$) {
    jquery = window.Checkout.$;
  }
  if (typeof jquery == 'undefined') {
    var jquerysrc = document.createElement('script');
    jquerysrc.type = 'text/javascript';
    jquerysrc.src = '//ajax.aspnetcdn.com/ajax/jQuery/jquery-3.4.1.min.js';
    document.body.appendChild(jquerysrc);
    waitjQueryLoad(function ($) {
      run($);
    });
  } else {
    run(jquery);
  }
})();
